import { Box, Stack } from '@mui/material';
import { StyledInput, StyledNotes, StyledTypography } from './styles.css';

type Props = {
  sx?: any;
  labelSx?: any;
  inputSx?: any;
  label: string;
  error?: boolean;
  disabled?: boolean;
  placeholder?: string;
  helperText?: string;
  value: number | string;
  type?: string;
  maxLength?: number;
  showCount?: boolean;
  onChange: (e: any) => void;
}

function Input(props: Props) {
  const charCount = typeof props.value === "string" ? props.value.length : 0;

  return (
    <Stack mt={2} sx={props.sx}>
      <StyledTypography style={props.labelSx}>{props.label}</StyledTypography>
      <Box sx={{ position: "relative" }}>
        <StyledInput
          error={props.error}
          variant="outlined"
          type={props.type}
          helperText={props.helperText}
          disabled={props.disabled}
          placeholder={props.placeholder}
          sx={props.inputSx}
          value={props.value}
          inputProps={{ maxLength: props.maxLength }}
          onChange={(e) => props.onChange(e.target.value)}
          multiline={props.inputSx?.['& .MuiInputBase-root']?.height !== undefined}
        />
        {props.showCount && props.maxLength && (
          <StyledNotes sx={{ position: "absolute", bottom: 10, right: 12, color: "#B0B0B0" }}>
            {charCount}/{props.maxLength}
          </StyledNotes>
        )}
      </Box>
    </Stack>
  );
}

export default Input;
